import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {setAuthToken} from '../services/api'
export default function ProtectedRoute({ children }) {
  const token = useSelector((state) => state?.auth?.token);
 setAuthToken(token)
  if (!token) return <Navigate to="/login" replace />;
  return children;
}
